<template>
  <v-list class="menu-left py-0">
    <mainMenuItem
      class="menu-border"
      v-for="(menuItem, i) in menuItems"
      :key="i"
      :MenuItem="menuItem"
    />
  </v-list>
</template>

<script>
import mainMenuItem from './mainMenuItem.vue';

export default {
  name: 'mainMenu',
  components: {
    mainMenuItem,
  },
  data() {
    return {
      menuItems: [
        {
          name: 'Dashboard',
          icon: 'view_quilt',
          slug: '/dashboard',
          routeName: 'dashboard',
          role: 'any',
        },
        {
          name: 'Klienci',
          icon: 'work',
          slug: '/klienci/1',
          routeName: 'clients',
          role: 'admin',
        },
        {
          name: 'Pliki',
          icon: 'folder',
          slug: '/pliki/',
          routeName: 'files',
          role: 'any',
        },
        {
          name: 'Użytkownicy',
          icon: 'people',
          slug: '/uzytkownicy/1',
          routeName: 'users',
          role: 'admin',
        },
        {
          name: 'Mój profil',
          icon: 'person',
          slug: '/profil',
          routeName: 'profile',
          role: 'any',
        },
        {
          name: 'Historia',
          icon: 'history',
          slug: '/historia/1',
          routeName: 'history',
          role: 'admin',
        },
        {
          name: 'FAQ',
          icon: 'question_answer',
          slug: '/faq',
          routeName: 'faq',
          role: 'any',
        },
      ],
    };
  },
};
</script>
